import React, { useState } from 'react';
import { Switch, Route, withRouter, RouteComponentProps } from 'react-router-dom';
import { FullLogo, Box, SelectDropdown, Button } from '@kistech/kis-ui';
import { selectors as clientsSelectors, actions as clientsActions, Client } from 'store/clients';
import { selectors as authSelectors } from 'store/auth';

import SignInView from 'views/SignInView';
import ResetPasswordView from 'views/ResetPasswordView';
import ProtectedRoutes from './ProtectedRoutes';
import { useSelector } from 'react-redux';
import { useActions } from 'hooks/useActions';
import ForgotPasswordView from 'views/ForgotPasswordView';
import { useStyles } from './styled';
import { Box as MuiBox, Container } from '@mui/material';
import { MenuPanel } from 'components/MenuPanel';
import { getSortedList } from 'utils/stringFormat';

const dashboardPaths = [
  '/kiosks',
  '/users',
  '/activityLog',
  '/deliveryLog',
  '/mediaCenter',
  '/configuration',
  '/settings'
];

const Routes: React.FC<RouteComponentProps> = ({ location }: RouteComponentProps) => {
  const path = location.pathname;
  const [showMenuPanel, setShowMenuPanel] = useState(false);

  // ACTION CREATORS AND SELECTORS
  const { setClientId } = useActions({ setClientId: clientsActions.setClientId });
  const client = useSelector(clientsSelectors.selectClient) as Client;
  const clients = useSelector(clientsSelectors.selectClients) as Client[];
  const isLoggedIn = useSelector(authSelectors.selectIsAuthenticated);

  // DETERMINES IF DROPDOWN SHOULD DISPLAY
  const shouldDisplayClientsSelect = dashboardPaths.some((dp) => path.includes(dp)) && clients.length > 1;
  const classes = useStyles({ isLoggedIn })();

  const onMenuClick = () => {
    setShowMenuPanel(true);
  };

  const onMenuPanelClose = () => {
    setShowMenuPanel(false);
  };

  return (
    <>
      <Box bg="x-light-gray" padding="6 0 0">
        <Container className={classes.routeContainer}>
          {/* HEADER */}
          <div className={classes.routeOuterContainer}>
            <MuiBox className={classes.routeButtonBox}>
              <Button className={classes.routeMenuButton} onClick={onMenuClick}>
                Menu
              </Button>
            </MuiBox>
            <MuiBox className={classes.routeKioskImage}>
              <FullLogo />
            </MuiBox>
            <MuiBox className={classes.routeSelectClient}>
              {shouldDisplayClientsSelect && (
                <SelectDropdown
                  placeholder="Select a Client"
                  items={getSortedList(clients, 'name')}
                  selectedItem={client}
                  onChange={(item: Client) => setClientId(item.id)}
                  itemToString={(item: Client) => (item ? item.name : '')}
                />
              )}
            </MuiBox>
          </div>
          {/* ROUTES */}
          <Switch>
            <Route exact path="/" component={SignInView} />
            <Route path="/resetpassword/:token?" component={ResetPasswordView} />
            <Route exact path="/forgotpassword" component={ForgotPasswordView} />
            <ProtectedRoutes />
          </Switch>
        </Container>
      </Box>
      {showMenuPanel && <MenuPanel onClose={onMenuPanelClose} isOpen={showMenuPanel} routePath={path} />}
    </>
  );
};

export default withRouter(Routes);
